import { Dispatch, SetStateAction } from 'react';
import { UseQueryResult, useQuery, useQueryClient } from 'react-query';
import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { companiesAssignedListKey, companiesListKey } from '../constants';
import { tampleteComapniesRoute } from '../api/constants';

type useGetAssignCompaniesListsProps = {
    templateId?: string | number;
    assigned?: string | number;
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useGetAssignCompaniesList = ({
    templateId,
    assigned,
    setErrorText = () => { },
}: useGetAssignCompaniesListsProps) => {
    const queryString = `?${templateId ? `template_id=${templateId}&` : ''}${assigned ? `assigned=1` : ''}`;

    const { data: companiesList, isFetching: isLoadingCompaniesList }: UseQueryResult<any, any> = useQuery({
        queryKey: [assigned ? companiesAssignedListKey : companiesListKey],
        queryFn: () =>

            axiosInstance
                .get(tampleteComapniesRoute + queryString)
                .then((res) => res.data),
        onSuccess: (data) => {
            setErrorText('');
        },
        onError: () => {
            setErrorText(errorMessage);
        },
        refetchOnWindowFocus: false,
    });

    return {
        companiesList,
        isLoadingCompaniesList,
    };
};
